import { IconPropsType } from '..';

export const HomeIcon = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M2 6.86663H11.6V3.66663H2V6.86663ZM13.2 16.4666H18V13.2666H13.2V16.4666ZM2 16.4666H11.6V13.2666H2V16.4666ZM2 11.6666H8.4V8.46663H2V11.6666ZM10 11.6666H18V8.46663H10V11.6666ZM13.2 6.86663H18V3.66663H13.2V6.86663Z" />
    </svg>
  );
};
